export default __webpack_public_path__ + "assets/icon-expenses.0031fccb.webp";